<template>
  <div class="container">
    <div class="row p-5 justify-content-center">
      <h2>
        Your account does not have the permission !
      </h2>
      <h2>
         Please send the request to <a href="mailto:ainguyenkaka@gmail.com">ainguyenkaka@gmail.com</a> !
      </h2>
    </div>
    <div class="row justify-content-center">
      <a href="/login" class="btn btn-primary">Sign In</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorPage',
  data () {
    return {
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/ErrorPage.vue